import { useContext } from 'react';
import { SettingsContext } from '../contexts';
import { SettingsContextProps } from '../types';

export const useSettings = (): SettingsContextProps => useContext(SettingsContext);
